import { STORAGE_PREFIX } from 'src/registry/utils/config';

import type { StoredTableState } from 'src/registry/types/table';

const storage = {
    getLanguage: () => {
        const language = JSON.parse(window.localStorage.getItem(`${STORAGE_PREFIX}language`) as string) as string;
        return language;
    },
};

const tableStorage = {
    getTableState: (key: string) => {
        const tableState = JSON.parse(
            window.localStorage.getItem(`${STORAGE_PREFIX}${key}`) as string,
        ) as StoredTableState;
        return tableState;
    },
    setTableState: (key: string, state: Partial<StoredTableState>) => {
        window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(state));
    },
    updateTableState: (key: string, state: Partial<StoredTableState>) => {
        const tableState = JSON.parse(
            window.localStorage.getItem(`${STORAGE_PREFIX}${key}`) as string,
        ) as StoredTableState;
        window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify({ ...tableState, ...state }));
    },
};

export { storage, tableStorage };
